/* =====================================================================
   Element Eight — inject subscription perks into the Seal widget
   ---------------------------------------------------------------------
   Adds a benefits list inside the "Subscribe & Save" card on the product
   page. Seal renders/re-renders its widget with JavaScript, so we watch
   for it and (re)inject idempotently. Skips the one-time card.
   ===================================================================== */
(function () {
  var PERKS = [
    ['20% OFF + FREE SHIPPING', ' on subscription orders'],
    ['SWAP PRODUCT', ' anytime and maintain discount'],
    ['FLEXIBILITY', ' to change delivery schedule or frequency'],
    ['CANCEL ANYTIME', ' after 3 billing cycles']
  ];

  function buildList() {
    var ul = document.createElement('ul');
    ul.className = 'ee-subscription-perks';
    PERKS.forEach(function (p) {
      var li = document.createElement('li');
      var strong = document.createElement('strong');
      strong.textContent = p[0];
      li.appendChild(strong);
      li.appendChild(document.createTextNode(p[1]));
      ul.appendChild(li);
    });
    return ul;
  }

  function inject() {
    var cards = document.querySelectorAll(
      '.sls-purchase-options-container .sls-option-container'
    );
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      // skip the one-time purchase card
      if (card.querySelector('input[data-type="one_time"], .sls-one-time-price')) continue;
      // already injected
      if (card.querySelector('.ee-subscription-perks')) continue;
      var target = card.querySelector('.sls-label-container') || card;
      target.appendChild(buildList());
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var run = function () { scheduled = false; inject(); };
    if (window.requestAnimationFrame) { window.requestAnimationFrame(run); }
    else { window.setTimeout(run, 16); }
  }

  function start() {
    inject();
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
